import type { IconKey } from '@/content/categories';
import {
  CalendarCheck,
  Dice5,
  FileText,
  Globe,
  GraduationCap,
  HeartPulse,
  type LucideIcon,
  Sparkles,
  Wallet,
} from 'lucide-react';

export const iconMap: Record<IconKey, LucideIcon> = {
  wallet: Wallet,
  'heart-pulse': HeartPulse,
  'graduation-cap': GraduationCap,
  'calendar-check': CalendarCheck,
  sparkles: Sparkles,
  globe: Globe,
  'file-text': FileText,
  'dice-5': Dice5,
};
